
export type UserValueObject = {
    id: bigint
    externalId: string
    createdAt: Date

}

export namespace UserValueObject {
    export function construct(o: any): UserValueObject {
        return {
            id: BigInt(o.id),
            externalId: String(o.externalId),
            createdAt: new Date(o.createdAt),
        }
    }

    export const description: Record<keyof UserValueObject, string> = {
        id: 'ID',
        externalId: '외부 ID',
        createdAt: '생성 시각',
    }
}